import React, { FC } from 'react';
import { Box, Tab, Tabs } from '@mui/material';
import { useSearchParams } from 'react-router-dom';
import Header from '../../components/Header';
import CashflowForecastTab from './CashflowForecastTab';
import CashflowHistoryTab from './CashflowHistoryTab';

/**
 * `eingebettet`: ohne eigenen Seitenkopf und Außenrand — so zeigt die Sektion /auswertungen die Seite als
 * Unterseite (Till 08.10.2026: einbetten, Nachschliff in P5). Ohne den Schalter unverändert.
 */
const PlxCashflowForecastPage: FC<{ eingebettet?: boolean }> = ({ eingebettet = false }) => {
  // Tab lives in the URL (?tab=history) so a view is linkable/shareable.
  const [searchParams, setSearchParams] = useSearchParams();
  const tabParam = searchParams.get('tab');
  const activeTab = tabParam === 'history' || tabParam === 'rueckblick' ? 1 : 0;

  const handleTabChange = (v: number) => {
    setSearchParams(
      (prev) => {
        const next = new URLSearchParams(prev);
        if (v === 1) {
          next.set('tab', 'history');
        } else {
          // Forecast is the default — drop tab + the history-only quarter param.
          next.delete('tab');
          next.delete('quarter');
        }
        return next;
      },
      { replace: false },
    );
  };

  const subtitle =
    activeTab === 0
      ? 'Erwartete Zahlungseingänge der nächsten 13 Wochen'
      : 'Reale Zahlungseingänge je KW vs eingefrorener Quartals-Plan';

  return (
    <Box m={eingebettet ? 0 : '20px'}>
      {!eingebettet && <Header title="Cashflow" subtitle={subtitle} />}

      <Box mb="20px">
        <Tabs value={activeTab} onChange={(_e, v) => handleTabChange(v)}>
          <Tab label="Forecast (13 Wochen)" />
          <Tab label="Rückblick / Plan vs Ist" />
        </Tabs>
      </Box>

      {activeTab === 0 && <CashflowForecastTab />}
      {activeTab === 1 && <CashflowHistoryTab />}
    </Box>
  );
};

export default PlxCashflowForecastPage;
